import { StageLayerSlotPlacement as BasicStageLayerSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const StageLayerSlotPlacement = withEditorSlotsState(
  BasicStageLayerSlotPlacement,
);
